import DataModel from '../../library/proto/data-model'

/**
 * @param {Number} id 該Model的辨識索引
 * @param {String} content 內容文字
 * @param {Number} sort 排序
 * @param {Number} is_index_use 是否為首頁項目
 * @param {Number} is_product_use 是否為產品頁項目
 * @param {String} published_at 公開時間
 * @param {String} finished_at 到期時間
 * @param {String} updated_user 更新使用者
*/
export default class MarqueesModel extends DataModel {
  constructor (args) {
    super(args)
    const entity = args || {}
    this.id = entity.id || 0
    this.content = entity.content || ''
    this.sort = entity.sort || 0
    this.is_index_use = entity.is_index_use || 0
    this.is_product_use = entity.is_product_use || 0
    this.published_at = entity.published_at || ''
    this.finished_at = entity.finished_at || ''
    this.updated_user = entity.updated_user || ''
  }

  toDatabase (addObject) {
    return {
      ...addObject
    }
  }
}
